module.exports = __webpack_public_path__ + "img/stack_2.a1e67a1e.png";